// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gyRP","icon":"styles_icon__wkrIZ"};